export function apiUrl() {
    return window.location.hostname.indexOf('localhost') >= 0 ? 'http://127.0.0.1:8000/api' : 'https://api.accionpyme.sorianoariza.com/api';
}


/** WEBPACK FOOTER **
 ** ./src/config.js
 **/